<template>
  <i :class="['bf-icon', `icon-${size}`, `icon-distro-${name}`]" class="cursor-pointer" />
</template>

<script>
export default {
  name: 'DistroIcon',
  props: {
    name: {
      type: String,
      required: true,
      default: '',
    },
    size: {
      type: String,
      default: 'm',
    },
  },
  computed: {
  },
}
</script>